import type { ServiceModel } from '@models/service'

type AutoSelectProviderParams = {
  providerId?: number,
  service?: ServiceModel,
}

const autoSelectProviderId = (params: AutoSelectProviderParams) => {
  const { providerId, service } = params
  const providerIds = service?.assigned_agency_provider_ids || []

  // If the service only has one provider auto select to save a click
  if (!providerId && providerIds.length === 1){
    return { providerId: providerIds[0] }
  }

  if (providerId){
    return { providerId }
  }

  return { providerId: undefined }
}

export default autoSelectProviderId
